<template>
  <div id="container">
    <pay-success class="notfind pay" title="" text="" v-if="isPay" />
    <f-z-f class="notfind pay" title="" text="" v-if="!isPay" />
    <div class="btn">
      <div @click="PayBack()" v-if="isPay">{{$t('base.success')}}</div>
      <div @click="PayBack()" v-if="!isPay">{{$t('base.unsuccess')}}</div>
    </div>
  </div>
</template>
<script>
import FZF from "@/components/404.vue";
import PaySuccess from "@/components/paysuccess.vue";
export default {
  name: 'index',
  components: { FZF, PaySuccess },
  data() {
    return {
      isPay: null,
      isText: "",
      //?type=paysuccess
      //?type=payerror
      //?type=chpsuccess
      //?type=chperror
      //?type=waresuccess
      //?type=wareerror
      //?type=paypal
      //window.webkit.messageHandlers.(name).postMessage(键值对)
    }
  },
  mounted() {
    window.PayBack = this.PayBack;
  },
  created() {
    this.isPay = (this.$route.query.type.indexOf('success')) != -1 ? true : false
    if (this.$route.query.type.indexOf('pay') != -1) {
      this.isText = "order"
    } else if (this.$route.query.type.indexOf('chp') != -1) {
      this.isText = 'chp'
    } else if (this.$route.query.type.indexOf('ware') != -1) {
      this.isText = 'ware'
    }else if (this.$route.query.type.indexOf('store') != -1) {
      this.isText = 'store'
    }
  },
  methods: {
    PayBack() {
      let that = this
      let ua = navigator.userAgent.toLowerCase();
      console.log('ua',ua)
      //android终端
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1|| ua.indexOf('android') > -1|| ua.indexOf('adr') > -1;
      console.log('isAndroid',isAndroid)
      //ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      let data = { "status": this.isPay ? 1 : 0, "type": this.isText }
      if (!isAndroid) {
        //ios
        console.log(" 我是ios")
        //这里是和IOS商量好的写法，调用IOS的finishActivity方法
        try {
          window.webkit.messageHandlers.PayCallback.postMessage(data)
        } catch (error) {
          console.log('WKWebView post message');
        }
      } else if(isAndroid){
        //android
        console.log("我是android",JSON.stringify(data));
        //这里是和安卓商量好的写法，调用安卓的finishActivity方法
        //android.PayCallback('我是android测试传值');           
        android.PayCallback(JSON.stringify(data));           
      }
    }
  }
}

</script>
<style scoped>
.btn {
  width: 90%;
  margin: 0 auto;
}

.btn a,
.btn div {
  display: block;
  width: 60%;
  border-radius: 4px;
  padding: 12px;
  margin: 0 auto;
  text-align: center;
  font-size: 18px;
  color: #fff;
  background-color: #5F6DAE;
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/apppay.vue